module.exports = __webpack_public_path__ + "static/media/Montserrat-Bold.a3b387c9.ttf";